import * as React from "react";
import {
  Typography,
  Divider,
  Checkbox,
  FormControlLabel,
  Button
} from "@material-ui/core";
import FacebookLogin from "react-facebook-login";
import { FacebookProvider, LoginButton, Login } from "react-facebook";
import FacebookIcon from "@material-ui/icons/Navigation";
import { DubitoSvc } from "src/api";
import * as moment from "moment";
interface Props {}
interface State {}
export default class Extensions extends React.Component<Props, State> {
  state = {
    chromeExtensionEnabled:
      window.localStorage.getItem("chrome_extension") === "true",
    logins: {} as any
  };

  onFacebookResponse = userInfo => {
    //console.log("hey");
    //console.log(userInfo);
    DubitoSvc.facebookLogin({
      social_id: userInfo.profile.id,
      token: userInfo.tokenDetail.accessToken
    }).then(() => {
      this.getLogins();
    });
  };
  componentDidMount() {
    this.getLogins();
  }
  getLogins() {
    DubitoSvc.getSocialLogins().then(res => {
      const logins = {};
      if (res.facebook) {
        logins["facebook"] = res.facebook.expire_at;
      }
      this.setState({ logins });
    });
  }
  render() {
    return (
      <div style={{ margin: 16 }}>
        <Typography variant="display1">Settings</Typography>
        <Divider />
        <div style={{ marginTop: 24, marginBottom: 24 }}>
          <Typography variant="headline">Social Login</Typography>

          <div style={{ marginTop: 24 }}>
            {/*       <FacebookLogin
              appId="213471075795721"
              autoLoad={true}
              fields="name,email,picture"
              callback={this.onFacebookResponse}
            /> */}
            <FacebookProvider appId="213471075795721">
              {/*     <LoginButton scope="email" onCompleted={this.onFacebookResponse}>
                <Button>Login via Facebook</Button>
              </LoginButton> */}
              <Login scope="email" onCompleted={this.onFacebookResponse}>
                {({ loading, handleClick, error, data }) => (
                  <Button variant="outlined" onClick={handleClick}>
                    <img
                      style={{ height: 24, marginRight: 4 }}
                      src={require("../../assets/facebook-icon.svg")}
                    />
                    Facebook
                  </Button>
                )}
              </Login>
              <Typography variant="caption" style={{ marginTop: 12 }}>
                {this.state.logins.facebook ? "Connected" : "Connect"}
              </Typography>
              {this.state.logins.facebook && (
                <Typography variant="caption" style={{ marginTop: 12 }}>
                  Expires {moment(this.state.logins.facebook).fromNow()}.
                </Typography>
              )}
            </FacebookProvider>
          </div>
        </div>
        <Divider />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/settings/index.tsx